<template>
  <v-btn
    rounded
    small
    color="secondary"
    :block="isMobile()"
    @click="
      $router.push({
        name: 'editar-dependente',
        params: { id: dependente.codigo },
      })
    "
  >
    <v-icon size="17" class="mr-1">mdi-pencil</v-icon> Editar Dependente</v-btn
  >
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  props: {
    dependente: Object,
  },
  methods: {
    ...mapMutations("atestado", ["setDados"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.setDados("");
  }
};
</script>

<style>
</style>